module.exports = __webpack_public_path__ + "d94bfed366b921fc425c21260e1a0773.png";